// Source:
// https://www.bundesnetzagentur.de/cln_1432/DE/Sachgebiete/Telekommunikation/Unternehmen_Institutionen/Nummerierung/Rufnummern/ONRufnr/ON_Einteilung_ONB/ON_ONB_ONKz_ONBGrenzen_Basepage.html?nn=316054
const germanyMobilePrefixes = [
  '151',
  '152',
  '155',
  '157',
  '159',
  '160',
  '162',
  '163',
  '170',
  '171',
  '172',
  '173',
  '174',
  '175',
  '176',
  '177',
  '178',
  '179',
];

export default class MobilePhoneNumber {
  msisdn : string;
  normalizedMsisdn : string;

  constructor(msisdn : string) {
    this.msisdn = msisdn;
    this.normalizedMsisdn = msisdn.replace(/[^\d]/g, '');
  }

  mobilePrefix() {
    const cleanMsisdn : string = this.normalizedMsisdn.replace(/^(49|0)/, '');
    return germanyMobilePrefixes.find((prefix) => cleanMsisdn.startsWith(prefix));
  }

  pretty() : string {
    const foundPrefix = this.mobilePrefix();

    if (foundPrefix) {
      const cleanMsisdn = this.normalizedMsisdn.replace(/^(49|0)/, '');
      return `0${foundPrefix} ${cleanMsisdn.replace(foundPrefix, '').replace(/^\s+/, '')}`;
    }

    return this.msisdn;
  }
}

export const formatMsisdn = (msisdn: string) => new MobilePhoneNumber(msisdn).pretty();
